import React, { useState } from 'react';
import { useNavigate } from 'react-router';
import baseURL from '../../url';

export default function LoginSimple() {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const navigate = useNavigate();

    const handleLogin = async (e) => {
        e.preventDefault();

        try {
            const formData = new FormData();
            formData.append('email', email);
            formData.append('contrasena', password);
            formData.append('iniciar_sesion', true);

            const response = await fetch(`${baseURL}/login.php`, {
                method: 'POST',
                body: formData,
            });

            if (!response.ok) {
                console.error('Error en la respuesta del servidor');
                return;
            }

            const data = await response.json();
            console.log('Respuesta del login:', data);

            if (data.mensaje) {
                // Redirigir inmediatamente
                navigate('/dashboard');
            } else if (data.error) {
                console.error('Error de login:', data.error);
            }
        } catch (error) {
            console.error('Error en el fetch:', error);
        }
    };

    return (
        <div className="formContain">
            <h2>Administrador</h2>
            <form onSubmit={handleLogin} className="formAuth">
                <div className="inputsAuth">
                    <label htmlFor="email">Email:</label>
                    <input
                        type="email"
                        id="email"
                        name="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                        placeholder="Email"
                    />
                </div>
                <div className="inputsAuth">
                    <label htmlFor="password">Contraseña:</label>
                    <input
                        type="password"
                        id="password"
                        name="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                        placeholder="Contraseña"
                    />
                </div>

                <button type="submit" className="btn">
                    Iniciar Sesión
                </button>
            </form>
        </div>
    );
}